
import React, { useState, useEffect } from 'react';

import { ajaxor0 } from '../../../common/basic';
import getNLS from '../../../common/_NLS';

import Item from './item';

export default props=>{
  // if(!props) return <></>;
  // console.log("list d: ", props.depart);

  const [vTab, setTab] = useState('최신순');

  // vTab별
  function showMore() {
    if (vTab == "인기순") {
      // console.log("vHotNavi.current_page: ", typeof vHotNavi.current_page);
      goHots(parseInt(vHotNavi.current_page) + 1);
    } else if (vTab == "최신순") {
      goLates(vLateNavi.current_page + 1);
    }
  }

  
  useEffect(() => {
    // console.log("list[] d: ", props.depart);

    return () => null;
  }, []);


  useEffect(() => {
    // console.log("list[d] d: ", props.depart);

    if (typeof props.depart == 'undefined') {
      // console.log("지정했는데 초기로딩인경우는 패스");
    }else if ( props.depart=='전체' ) {
      // console.log("지정안해서 전체, 인기순보기도 로딩");
      goHots();
    }else{
      // console.log("지정하면 인기순은 무쓸, 초기화: ");
      setHotList([,]);
      setHotNavi({});
    }
    goLates();
    return () => { ; }
  }, [props.depart]);

  // 1. 인기순 리스트
  const [vHotList, setHotList] = useState([,]);
  const [vHotNavi, setHotNavi] = useState({});
  const [vDHotShowmore, setDHotShowmore] = useState('none');
  function goHots(nomination = 0, filter) {
    // console.log("nomination: ", nomination);

    // let nStr;
    // if (nomination > 1) nStr = "" + ((nomination-1)*30); // lcg30
    // let offsetStr = (nomination ? "offset=" + nStr : "");
    // ======>    url...  + offsetStr
    
    ajaxor0({
      url: "/magazines?"
        + (nomination ? "offset=" + ((nomination - 1) * 30) : "")
        // + offsetStr
        + "&limit=30" // lcg30
        + (nomination ? "&page=" + (nomination) : "")
        + '&order=view_count3'

      // url: "/magazines?offset=0&limit=30"
      //   + (nomination ? "&page=" + (nomination) : "")
      //   + '&order=view_count3'
      ,callback: callback,
    });
    function callback(r) {
      nomination
        ? setHotList(vHotList.concat(r.data)) // 지정했으면 append
        : setHotList(r.data); // 지정안했으면 초기화
      if (r && r.pagination && r.pagination.current_page)
        r.pagination.current_page = parseInt(r.pagination.current_page);
      // console.log("setHotNavi: ", r.pagination);
      setHotNavi(r.pagination);
      setDHotShowmore(r.data && r.data.length == 30?'block':'none'); // lcg30
    }
  }

  // 2. 최신순 리스트
  const [vLateList, setLateList] = useState([,]);
  const [vLateNavi, setLateNavi] = useState({});
  const [vDLateShowmore, setDLateShowmore] = useState('none');
  function goLates(nomination = 0, filter) {
    var pageno = nomination ? nomination : 1;

    // console.log("props.depart: ", props.depart, typeof props.depart);
    if(typeof props.depart=='undefined'){
      // console.log("depart를 지정했는데 초기로딩인경우는 undefined이고, 이때ajax는 패쓰.");
      return;
    }
    ajaxor0({
      url: "/magazines?"
        + (nomination ? "offset=" + ((nomination - 1) * 30) : "")
        // + offsetStr
        + "&limit=30" // lcg30
        + (nomination ? "&page=" + (nomination) : "")
        + ( (props.depart == '전체') ? "" : "&depart=" + props.depart )


      // url: "/magazines?offset=" + (pageno*30-30) +"&limit=30"
      //   + ("&page=" + (pageno)) // 서버에서 처리하는게 있어서 포함시켜줘야된다.
      //   + ((props.depart == '전체')
      //     ? "" : "&depart="+props.depart )
      , callback: callback,
    });
    function callback(r) {
      nomination
        ? setLateList(vLateList.concat(r.data)) // 지정했으면 append
        : setLateList(r.data); // 지정안했으면 초기화
      if(r && r.pagination && r.pagination.current_page)
        r.pagination.current_page = parseInt(r.pagination.current_page);
      // console.log("setLateNavi: ", r.pagination);
      setLateNavi(r.pagination);
      setDLateShowmore(r.data && r.data.length == 30 ? 'block' : 'none');
    }
  }


  const [order, setOrder] = useState('최신순');

  const value2List = {
    "인기순": vHotList,
    "최신순": vLateList,
  };

  return (<div className="pan6">
    <style jsx>{`

.display-inline{
  display: inline;
  margin: 0 7px;
  vertical-align: middle;
  
}

.tabon.tab {
  font-family: NotoSansCJKkr;
  font-size: 14px;
  color: #343a40;
}

.tab {
  font-family: NotoSansCJKkr;
  font-size: 14px;
  color: #adb5bd;
  margin-right: 12px;
}

// 3 in 1 형 테이블
.table1 {
  width: 100%;
}

.td1{
    width: 410PX;
    display: inline-block;
    padding: 0;
    margin:14px;
    vertical-align: top;
}

.leftside{
  margin-left:0;

}
.rightside{
  margin-right:0;
}

.column{
  width: 33%;
}

.MegazineList{
  padding-top: 0;
}

@media all and (max-width:606px) {
  .td1{
    width: 100%;
    margin:0px;
    padding:16px 0;
    /* padding: 0 0 16px 0; */
  }

  
  .leftside, .rightside{
    margin:0px;
  }
  
}


`}</style>
    {(props.depart == '전체') ? (<>
      <a className={"tab " + (vTab == '인기순' ? "tabon" : "")}
        onClick={() => setTab('인기순')}
      >{getNLS("인기순")}</a>
      <a className={"tab " + (vTab == '최신순' ? "tabon" : "")}
        onClick={() => setTab('최신순')}
      >{getNLS("최신순")}</a>
    </>)
      : <></>// 카테고리치고들어온거는 탭이없다.
    }

    <div className="table1">
      <div className="aline">
        {(
          (props.depart == '전체') ?
            (value2List[vTab])
            : (vLateList) // 카테고리치고들어온거는 무조건 최신순만
        ).map((v, i) =>
          <div key={i} className={"td1 " + (i % 3 == 0 ? "leftside" : (i % 3 == 2 ? "rightside" : "")) + " "}>
            <Item me={v} data={JSON.parse(v.caption)} />
          </div>
        )}
      </div>
    </div>
    <div className={"see-more iii"} 
      onClick={showMore}
      style={{
        display: (
          (vTab == "인기순") ? vDHotShowmore :
            (vTab == "최신순") ? vDLateShowmore : "")
      }}
    >+ {getNLS("기사 더 보기")}</div>


    <div className="see-more" style={{
      cursor: "auto",
      display: ((
        (typeof props.depart != 'defined' && props.depart != '전체') ?
          (vLateList)
          : (value2List[vTab])
      ).length == 0) ? 'block' : 'none'
    }}>결과가 없습니다.</div>


  </div>);
}